import React from 'react';
import { Banner } from '@vcc-gcs/bookingengine-shared-frontend';

const ErrorView = () => {
  return <Banner bannerType={'error'} labelTextId={`common.unauthorized`} visibleTimeoutInSeconds={0} />;
};

export { ErrorView };
